import { ReactNode } from "react";
import { HStack, Stack, Text } from "@chakra-ui/react";
import { ColorModeSwitcher } from "ColorModeSwitcher";
import { PRIMARY_COLOR } from "helpers/constants";
import Menu from "./Menu";
import "styles/custom.css";

interface Props {
  children: ReactNode;
}
export default function Layout({ children }: Props) {
  return (
    <Stack height={"100vh"} spacing={0}>
      <HStack
        justifyContent="space-between"
        bg={PRIMARY_COLOR}
        px={["2", "6"]}
        py={2}
      >
        <HStack>
          <Menu />
          <Text fontSize="2xl" color={"white"}>
            {process.env.REACT_APP_NAME ?? "Inventory"}
          </Text>
        </HStack>
        <HStack>
          <ColorModeSwitcher justifySelf="flex-end" />
        </HStack>
      </HStack>
      <Stack
        py={2}
        px={["2", "6"]}
        overflow={"auto"}
        flex={1}
        height={"100%"}
        spacing={0}
        className="invisible-scrollbar"
      >
        {children}
      </Stack>
    </Stack>
  );
}
